<div class="flex h-full flex-col">
  <mat-sidenav-container class="shell-container h-full">
    <mat-sidenav [disableClose]="true" mode="side" [opened]="true" class="border-r border-neutral-200">
      <div class="flex h-full flex-col">
        <!-- Overview Back Button -->
        <div class="h-[45px] w-full">
          <a
            [routerLink]="['/overview']"
            class="flex h-full w-full items-center border-b border-neutral-200 bg-neutral-50 px-4 py-3 text-xs font-medium text-gray-500 hover:bg-gray-50"
          >
            <dojo-icon [icon]="'arrow-left'" [size]="14" class="mr-2" />
            <span>Return to Overview</span>
          </a>
        </div>

        <div class="px-4 pb-2 pt-3">
          <exam-syllabus-select [allowedSyllabuses]="state.allowedSyllabuses" />
        </div>

        <div class="flex grow flex-col items-start gap-4">
          @if (state.availableRefReviewConfigs.length > 0) {
            <div class="flex w-full flex-col items-start px-4 py-2">
              <div class="text-primary mb-2 text-sm font-semibold">Review ref. questions</div>
              <div class="flex w-full flex-col gap-0.5">
                @for (config of state.availableRefReviewConfigs; track config.urlPart) {
                  <ng-container
                    *ngTemplateOutlet="
                      link;
                      context: {
                        icon: config.icon,
                        label: config.displayName,
                        route: [
                          '/',
                          RootUrlParts.Syllabus,
                          state.syllabusSlug,
                          SyllabusUrlParts.Validate,
                          ValidateUrlParts.ReferenceQuestion,
                          config.urlPart
                        ]
                      }
                    "
                  />
                }
              </div>
            </div>
          }

          @if (state.availableDerReviewConfigs.length > 0) {
            <div class="flex w-full flex-col items-start px-4 py-2">
              <div class="text-primary mb-2 text-sm font-semibold">Review der. questions</div>
              <div class="flex w-full flex-col gap-0.5">
                @for (config of state.availableDerReviewConfigs; track config.urlPart) {
                  <ng-container
                    *ngTemplateOutlet="
                      link;
                      context: {
                        icon: config.icon,
                        label: config.displayName,
                        route: [
                          '/',
                          RootUrlParts.Syllabus,
                          state.syllabusSlug,
                          SyllabusUrlParts.Validate,
                          ValidateUrlParts.DerivativeQuestion,
                          config.urlPart
                        ]
                      }
                    "
                  />
                }
              </div>
            </div>
          }
        </div>

        <div class="mt-auto flex w-full flex-col gap-1 p-4">
          <!-- Help Button -->
          <button
            (click)="toggleHelpSidenav()"
            class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
          >
            <dojo-icon [icon]="'question-circle'" [iconClass]="'text-secondary'" [size]="12" class="mr-1.5" />
            <span class="truncate">Help</span>
          </button>

          @if (state.user) {
            <a
              [matMenuTriggerFor]="userMenu"
              class="text-secondary flex w-full max-w-full items-center gap-2 rounded-[0.75rem] px-2 py-1.5 font-semibold transition-colors hover:bg-neutral-50 group-[.is-compact]:px-2"
            >
              <dojo-profile-avatar [size]="20" class="shrink-0" />
              <span class="truncate text-sm" [matTooltip]="state.user.fullName">{{ state.user.fullName }}</span>
            </a>
          }
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="!overflow-hidden bg-white">
      <div class="h-full overflow-y-auto">
        <router-outlet />
        <ng-content />
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<mat-menu #userMenu="matMenu" class="custom-mat-menu">
  <button mat-menu-item (click)="signOut()">
    <dojo-icon class="menu-icon" [icon]="'arrow-right-from-bracket'" />
    <span class="menu-item-label">{{ 'examdojo.registration.sign_out' | transloco }}</span>
  </button>
</mat-menu>

<ng-template #link let-icon="icon" let-label="label" let-route="route">
  <a
    [routerLink]="route"
    routerLinkActive="active"
    class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
    #rla="routerLinkActive"
  >
    <dojo-icon
      [icon]="icon"
      [iconClass]="rla.isActive ? 'text-sky-500' : 'text-secondary'"
      [size]="12"
      class="mr-1.5"
    />
    <span class="truncate" [matTooltip]="label">{{ label }}</span>
  </a>
</ng-template>
